export const ModalTemplate = `
<div class="modal__underlay"></div>
<div class="modal">
  {{{title}}}
  {{{content}}}
  {{{closeLink}}}
</div>
`;
